export type PurchaseReportSlug =
  | 'packaging'
  | 'food-and-drink'
  | 'result-overview'
  | 'emissions-over-time'
  | 'carbon-intensity-over-time'
  | 'emissions-by-site'
  | 'emissions-by-supplier'
  | 'emissions-by-tag'
  | 'emissions-by-category'
  | 'purchased-items-food'
  | 'emissions-by-material'
  | 'purchased-items-packaging';

export type PurchaseReportSlugs = Record<string, PurchaseReportSlug>;

export const purchaseReportSlugs = {
  packaging: 'packaging',
  foodAndDrink: 'food-and-drink',
  resultOverview: 'result-overview',
  emissionsOverTime: 'emissions-over-time',
  emissionsBySite: 'emissions-by-site',
  emissionsBySupplier: 'emissions-by-supplier',
  emissionsByTag: 'emissions-by-tag',

  emissionsByCategory: 'emissions-by-category',
  purchasedItemsFood: 'purchased-items-food',

  emissionsByMaterial: 'emissions-by-material',
  purchasedItemsPackaging: 'purchased-items-packaging',
};
